export default __webpack_public_path__ + "static/N0219-f205ea26ec88c7057895fecc79a8c12b.png";